<div class="col-12 col-md-4 mx-auto px-2 text-center">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-12" style="text-align: end;">
        <img src="../../../assets/logo/header.png" class="img-fluid" alt="...">
      </div>
    </div>
    <!-- questionpage -->
    <div class="row py-4">
        <div *ngFor="let r of dataquestion; let i = index">
          <div *ngIf="r.line == questionpage">
            <div class="col-12 col-md-12">
              <p><b>{{r.line}}/{{totalquestion}}</b></p>
              <div *ngIf="r.line == 5">
                  <p><b>Karena Anda merupakan VIP Member kami, Anda dapat menikmati beberapa keuntungan seperti:</b></p>
                  <p>1. Pengumpulan point reward setiap Rp. 100.000 pembelanjaan Anda setara dengan 1 point.</p>
                  <p>2. Pengumpulan double point reward untuk Anda yang berbelanja di bulan ulang tahun Anda, di mana setiap Rp. 100.000 pembelanjaan Anda setara dengan dengan 2 point.</p>
                  <p>3. Point tersebut dapat Anda tukarkan untuk potongan harga pada saat pembelanjaan berikutnya:</p>
                  <ul>
                    <li>Tukarkan 10 point untuk potongan senilai Rp. 50.000</li>
                    <li>Tukarkan 20 point untuk potongan senilai Rp. 150.000</li>
                  </ul>
              </div>
              <p class="pt-4">
                <b>{{r.question}}</b><br>
                <small style="font-size: 10px ! IMPORTANT;color: #999;" *ngIf="r.type === 'checkbox'">*Jawaban bisa di pilih lebih dari satu</small>
              </p>
            </div>

            <form>
              <div *ngIf="r.type === 'checkbox'">
                <div class="col-12 col-md-12 pb-3">
                  <div class="row" style="place-content: center;">
                    <div class="col-12 col-md-12"  *ngFor="let v of r.options; let l = index">
                      <div class="bTcW col-12 rounded-pill">
                        <div class="form-check pt-1 pb-1" *ngIf="v.linequestion == 6">
                            <div *ngIf="v.id == 32; else disabled">
                                <input class="form-check-input" id="q_satu{{v.id}}" type="checkbox" [ngModel]="selectedItems.includes(v.id)" name="q_satu{{v.id}}" (change)="handleCheckboxChange($event, v)" [disabled]="Tidak">
                                <label class="form-check-label" style="font-size: 12px!important;" for="q_satu{{v.id}}">{{v.options}} </label>
                            </div>
                            <ng-template #disabled>
                              <input class="form-check-input" id="q_satu{{v.id}}" type="checkbox" [ngModel]="selectedItems.includes(v.id)" name="q_satu{{v.id}}" (change)="handleCheckboxChange($event, v)" [disabled]="Ya">
                              <label class="form-check-label" style="font-size: 12px!important;" for="q_satu{{v.id}}">{{v.options}} </label>
                            </ng-template>
                        </div>
                        <div class="form-check pt-1 pb-1" *ngIf="v.linequestion != 6">
                          <input class="form-check-input" id="q_satu{{v.id}}" type="checkbox" [ngModel]="selectedItems.includes(v.id)" name="q_satu{{v.id}}" (change)="handleCheckboxChange($event, v)">
                          <label class="form-check-label" style="font-size: 12px!important;" for="q_satu{{v.id}}">{{v.options}} </label>
                        </div>
                      </div>
                      <div  class="col-12 rounded-pill" *ngIf="v.id == 8 && selectedItems.includes(v.id)" style="margin: 10px;">
                        <input  type="text" class="form-control" [(ngModel)]="v.note" name="lainnya" placeholder="*Media sosial lain yang Anda miliki"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="r.type === 'radio'">
                <div class="col-12 col-md-12 pb-3">
                  <div class="row" style="place-content: center;">
                    <div class="col-12 col-md-12"  *ngFor="let v of r.options; let l = index">
                      <div class="bTcW col-12 rounded-pill">
                        <div class="form-check pt-1 pb-1">
                          <!-- <input
                          type="radio"
                          class="form-check-input"
                          [name]="'radio_' + v.linequestion"
                          [id]="'radio_' + v.id"
                          [value]="v.id"
                          [checked]="selectedOption[v.linequestion] === v.id"
                          (change)="handleRadioChange(v, v.linequestion)"
                          />
                          <label class="form-check-label" style="font-size: 12px!important;" for="radio_{{v.id}}">{{v.options}}</label> -->

                          <!-- <input class="form-check-input" id="radio_{{v.id}}" type="radio" [value]="v.id" [checked]="selectedOption.includes(v.id)" [ngModel]="selectedOption.includes(v.id)" name="radio_{{v.id}}" (change)="handleRadioChange($event, v)"> -->
                          <input class="form-check-input" id="{{v.id}}" type="radio" name="options{{v.id}}" [value]="v.id" [checked]="selectedOption.includes(v.id)" (change)="handleRadioChange($event, v)" >
                          <label class="form-check-label" style="font-size: 12px!important;" for="{{v.id}}">{{v.options}} </label>
                        </div>

                      </div>
                      <div class="col-12 rounded-pill" *ngIf="v.linequestion == 4 && selectedOption.includes(v.id)" style="margin: 10px;">
                        <input type="text" class="form-control" [(ngModel)]="v.keterangan" name="lainnya" placeholder="*Mohon berkenan menjelaskan lebih lanjut"/>
                      </div>
                      <div class="col-12 rounded-pill" *ngIf="v.linequestion == 8 && selectedOption.includes(v.id)" style="margin: 10px;">
                        <input type="text" class="form-control" [(ngModel)]="v.keterangan" name="lainnya" placeholder="*Mohon berkenan menjelaskan lebih lanjut"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ selectedOption | json }}</pre> -->
              <div *ngIf="r.type === 'essay'">
                <div class="col-12 col-md-12 pb-3">
                  <div class="row" style="place-content: center;">
                    <div class="col-12 col-md-12"  *ngFor="let v of r.options; let l = index">
                      <div *ngIf="v.id == 35; else essayview">
                        <label class="form-check-label pt-4" style="font-size: 12px!important;" *ngIf="v.lineoptions == 1">{{v.options}} </label>
                        <div class="col-12 rounded-pill" style="margin: 5px;">
                          <input  type="text" class="form-control" [(ngModel)]="v.note" name="sepatu{{v.id}}" placeholder="{{v.lineoptions}}" required="">
                        </div>
                      </div>
                      <ng-template #essayview>
                        <label class="form-check-label pt-4" style="font-size: 12px!important;" *ngIf="v.lineoptions == 1">{{v.options}} </label>
                        <div class="col-12 rounded-pill" style="margin: 5px;">
                          <input  type="text" class="form-control" [(ngModel)]="v.note" name="tas{{v.id}}" placeholder="{{v.lineoptions}}" required="">
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <p class="error-message" *ngIf="errorResultSurvey">{{errorResultSurvey}}</p>
          </div>
        </div>

        <div class="col-12 col-md-12" *ngIf="!this.showbuttonclaim">
          <div class="row">
            <div class="col-6 col-md-6 text-start">
              <!-- [disabled]="disablebutton" -->
              <button (click)="onPrevious()" class="btn btn-dark btn-sm bTc" type="button">
                <i class="bi bi-chevron-left"></i>
              </button>
            </div>
            <div class="col-6 col-md-6 text-end">
              <button (click)="onNext()" class="btn btn-dark btn-sm bTc" type="button">
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 pt-2" *ngIf="this.showbuttonclaim">
          <div class="row">
            <div class="col-12 col-md-12 text-center">
              <ng-container *ngIf="isLoading;else onFilters">
                <button class="btn btn-dark" type="button" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
              </ng-container>
              <ng-template #onFilters>
                <button (click)="onSave()" class="btn btn-light btn-md bTcClaim col-12 rounded-pill" type="button">
                  Claim your 20% discount here
                </button>
              </ng-template>
            </div>
          </div>
        </div>

    </div>
  </div>
</div>




